// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cw-z","play":"dw-z"};